import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isLargeScreen } from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { IncidentsService } from '../../../pages/pages/incidents/incidents.service';
import { UserProfileService } from '../../../profile/user-profile/user-profile.service';
import { MediaPreviewComponent } from '../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { ModifyLetterheadLogoComponent } from '../../../shared/components/modify-letterhead-logo/modify-letterhead-logo.component';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'gtapp-preview-incident-report',
  standalone: false,
  templateUrl: './preview-incident-report.component.html',
  styleUrl: './preview-incident-report.component.scss',
})
export class PreviewIncidentReportComponent implements OnInit, OnDestroy {
  subscriberInfo: any;
  detailData: any;
  timeZoneData: any;
  incidentId: any;
  largeView = isLargeScreen;

  today = new Date();

  incidentCommentFiles: any = [];
  sumamaryTableData: any = [];

  constructor(
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private dialogService: ModalDialogueService,
    private router: Router,
    private toasterService: ToasterService,
    private route: ActivatedRoute,
    private incidentService: IncidentsService,
    private profileService: UserProfileService,
  ) {}
  ngOnDestroy(): void {}
  ngOnInit(): void {
    this.incidentId = this.route.snapshot.queryParamMap.get('incidentId');
    if (!this.incidentId) {
      this.router.navigate(['/pc']);
    }
    this.getIncidentDetail();
  }
  modifyLetterHeadLogo() {
    const dialogRef = this.dialogService.open(ModifyLetterheadLogoComponent, {
      data: {
        logoUsed: this.subscriberInfo?.logo_used,
        siteData: {
          id: this.detailData?.site?.id,
          company_name: this.detailData?.site?.company_name,
        },
        clientData: {
          id: this.detailData?.company?.id,
          company_name: this.detailData?.company?.company_name,
          is_subcontracting: this.detailData?.company?.is_subcontracting,
        },
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.getSubscriberInfo();
      }
    });
  }
  scrollToSection(event: Event, sectionId: string) {
    event.preventDefault();
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  }
  onOpenImage(event: any, data: any) {
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;

    this.dialogService.open(MediaPreviewComponent, {
      data: { mediaSrc: srcAttr.nodeValue, timeStamp: data.updated_at },
    });
  }
  getSubscriberInfo() {
    this.profileService
      .fetchCompanyDetails({
        preview_report: 1,
        site_id: this.detailData?.site?.id,
      })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.subscriberInfo = response?.data;
        }
      });
  }
  getIncidentDetail() {
    this.spinnerService.show();
    this.incidentService
      .retrieveIncident(this.incidentId)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.formatData(response);

          this.getSubscriberInfo();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }

        this.spinnerService.hide();
      });
  }
  formatData(response: any) {
    this.detailData = response?.data;

    const hideGuardColumn = this.detailData?.additional_info?.hide_guard_column;

    if (typeof hideGuardColumn !== 'boolean') {
      this.detailData.additional_info.hide_guard_column = true;
    }

    this.timeZoneData = response?.time_zone_data;

    this.incidentCommentFiles = [
      ...response?.history?.filter((item: any) =>
        //1 = added comment
        //2 = take photo from camera
        //3 = comment changed
        //5 = corrective actions changed
        //7 = incident time changed
        //8 = incident report sent
        //9 = report re-sent
        //10 = incident type changed
        //11 = uploaded photo from device
        [2, 11].includes(item?.event_action),
      ),
    ];
    this.sumamaryTableData = [
      ...response?.history?.filter(
        (item: any) =>
          //1 = added comment
          //2 = take photo from camera
          //3 = comment changed
          //5 = corrective actions changed
          //7 = incident time changed
          //8 = incident report sent
          //9 = report re-sent
          //10 = incident type changed
          //11 = uploaded photo from device
          [2, 11].includes(item?.event_action) &&
          !this.detailData?.additional_info?.hide_uploads,
      ),
    ];

    this.appService.initializeBootstrapTooltips();
  }
  async onEmailReport() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Email Report',
      },
    });
    const dialogResponse = await firstValueFrom(dialogRef.afterClosed());

    if (dialogResponse === true) {
      const subscriberUserId =
        this.appService.getUserData()?.subscriber?.subscriber_user_id;

      this.spinnerService.show('Mailing Report');
      this.incidentService
        .updateIncidentDetails(
          {
            incident_id: this.detailData?.id,
            user_ids: [subscriberUserId],
            send_report: 1,
          },
          {},
        )
        .then((response: any) => {
          if (response?.status == 'success') {
            if (response?.data) {
              this.detailData = response['data'];

              this.formatData(response);
            }
            this.spinnerService.hide();
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
            this.spinnerService.hide();
          }
        });
    }
  }
}
